import { Component, inject } from '@angular/core'
import { UsersService } from '@client/Services/UsersService'
import HttpError, { FormErrors } from '@ui/HttpError'
import { MatSnackBar } from '@angular/material/snack-bar'
import {
	FormValidationComponent,
	ValidationMessages,
} from '@ui/Components/Form/FormValidation.Component'
import { FormsModule, ReactiveFormsModule, Validators } from '@angular/forms'
import { CardComponent } from '@ui/Components/Card/Card.Component'
import { CardContentComponent } from '@ui/Components/Card/CardContent.Component'
import { TextInputComponent } from '@ui/Components/Form/TextInput/TextInput.Component'
import { RaisedButtonComponent } from '@ui/Components/Form/Button/RaisedButton.Component'

@Component({
	selector: 'forgotten-password',
	templateUrl: './ForgottenPassword.Component.html',
	styleUrls: ['../Auth.css'],
	imports: [
		CardComponent,
		CardContentComponent,
		FormsModule,
		ReactiveFormsModule,
		TextInputComponent,
		RaisedButtonComponent,
	],
})
export class ForgottenPasswordComponent extends FormValidationComponent {
	public formErrors: FormErrors = {
		email: '',
	}

	protected validationMessages: ValidationMessages = {
		email: {
			required: 'Email is required',
		},
	}

	private readonly usersService: UsersService

	private readonly matSnackBar: MatSnackBar

	constructor() {
		super()
		this.usersService = inject(UsersService)
		this.matSnackBar = inject(MatSnackBar)
	}

	public resetPassword = async (): Promise<void> => {
		this.validateForm()

		if (!this.form.valid) {
			return
		}

		try {
			await this.usersService.sendResetPasswordEmail(
				this.form.controls.email.value as string,
			)

			this.matSnackBar.open(
				'Password reset link has been emailed to you',
				'Okay',
			)
		} catch (error) {
			if (error instanceof HttpError) {
				if (error.isUnprocessableEntity()) {
					this.formErrors = error.handleFormErrors(this.formErrors, 'school')
					this.markInvalidFields()
				}
				return
			}

			throw error
		}
	}

	protected buildForm = (): void => {
		this.form = this.formBuilder.group({
			email: ['', [Validators.required]],
		})
	}
}
